import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledWrapper = styled(Box)<{ greyBackground: boolean }>(({ theme, greyBackground }) => ({
  width: 290,
  borderRadius: theme.spacing(0.5),
  maxHeight: 355,
  overflowY: 'auto',
  ...(greyBackground ? { backgroundColor: theme.palette.coolGrey[100] } : {}),
}));

export const StyledContainer = styled(Box)<{ greyBackground: boolean }>(({ theme, greyBackground }) => ({
  padding: theme.spacing(1.25),
  ...(greyBackground ? { backgroundColor: theme.palette.coolGrey[100] } : {}),
}));
